export const mediaAndDigitalCommunicationsConst = {
  path: "/single-programs/media-and-digital-communications",
  title: "ФАКУЛЬТЕТ КОММУНИКАЦИЙ — МЕДИА И DIGITAL-КОММУНИКАЦИИ",
  contentJSX: (
    <>
      <p>
        <strong>Диплом: </strong>бакалавра / магистра
      </p>
      <p>
        <strong>Формы обучения: </strong>очно или дистанционно
      </p>
      <p>
        <strong>Форма связи: </strong>Получить консультацию приемной комиссии
      </p>
      <h2>Медиа и Digital-коммуникации — язык современного мира</h2>
      <p>
        Эта программа создана для нового поколения профессионалов, умеющих эффективно управлять вниманием аудитории, строить бренд-стратегии
        и говорить с миром на языке цифровых технологий.
      </p>
      <p>
        Медиа и коммуникации сегодня — это синтез креатива, аналитики и стратегического мышления. Студенты осваивают SMM, сторителлинг,
        брендинг, медиаменеджмент и работу с визуальным контентом, готовясь к карьерному старту в международных компаниях, стартапах и
        креативных агентствах.
      </p>
      <h2>Что вы будете изучать?</h2>
      <ul>
        <li>Стратегические коммуникации</li>
        <li>SMM и управление сообществами</li>
        <li>Брендинг и визуальная айдентика</li>
        <li>Сторителлинг и создание контента</li>
        <li>Digital-маркетинг и аналитика</li>
        <li>Медиапланирование и медиаменеджмент</li>
        <li>Работа с инфлюенсерами и PR</li>
        <li>Право в медиа и цифровой этике</li>
      </ul>
      <p>Программа включает реальные кейсы, работу с медиаинструментами, практику в агентствах и компаниях-партнёрах.</p>
      <h2>Кем можно работать после окончания?</h2>
      <ul>
        <li>Digital-специалист или стратег</li>
        <li>Контент-директор или креативный продюсер</li>
        <li>Менеджер по коммуникациям в международных проектах</li>
        <li>SMM-менеджер и бренд-менеджер</li>
        <li>Консультант по цифровой трансформации брендов</li>
      </ul>
      <h2>Зарплата в Европе:</h2>
      <p>
        от <strong>€45,000 до €90,000 в год</strong> — особенно востребованы специалисты с междисциплинарными навыками и знанием языков.
      </p>
      <h2>Почему выбирают нас?</h2>
      <ul>
        <li>Европейский диплом международного образца</li>
        <li>Актуальная программа, созданная с участием индустрии</li>
        <li>Гибкий формат обучения: очно или дистанционно</li>
        <li>Реальные проекты, стажировки и портфолио</li>
        <li>Поддержка трудоустройства в странах ЕС</li>
        <li>Возможность учиться на русском или английском языке</li>
      </ul>
      <p>Медиа — это профессия будущего. Управляйте вниманием, формируйте смыслы, влияйте на мир.</p>
      <h2>Как поступить?</h2>
      <p>Приёмная комиссия поможет вам определиться с направлением, собрать документы и пройти весь процесс поступления.</p>
    </>
  ),
  contentSearch: `
    Диплом: бакалавра / магистра
    Формы обучения: очная или дистанционная
    Форма связи: Получить консультацию приемной комиссии
    Медиа и Digital-коммуникации — язык современного мира
    Эта программа создана для нового поколения профессионалов, умеющих эффективно управлять вниманием аудитории, строить бренд-стратегии и говорить с миром на языке цифровых технологий.
    Медиа и коммуникации сегодня — это синтез креатива, аналитики и стратегического мышления. Студенты осваивают SMM, сторителлинг, брендинг, медиаменеджмент и работу с визуальным контентом, готовясь к карьерному старту в международных компаниях, стартапах и креативных агентствах.
    Что вы будете изучать?
    • Стратегические коммуникации
    • SMM и управление сообществами
    • Брендинг и визуальная айдентика
    • Сторителлинг и создание контента
    • Digital-маркетинг и аналитика
    • Медиапланирование и медиаменеджмент
    • Работа с инфлюенсерами и PR
    • Право в медиа и цифровой этике
    Программа включает реальные кейсы, работу с медиаинструментами, практику в агентствах и компаниях-партнёрах.
    Кем можно работать после окончания?
    • Digital-специалист или стратег
    • Контент-директор или креативный продюсер
    • Менеджер по коммуникациям в международных проектах
    • SMM-менеджер и бренд-менеджер
    • Консультант по цифровой трансформации брендов
    Зарплата в Европе: от €45,000 до €90,000 в год — особенно востребованы специалисты с междисциплинарными навыками и знанием языков.
    Почему выбирают нас?
    • Европейский диплом международного образца
    • Актуальная программа, созданная с участием индустрии
    • Гибкий формат обучения: очно или дистанционно
    • Реальные проекты, стажировки и портфолио
    • Поддержка трудоустройства в странах ЕС
    • Возможность учиться на русском или английском языке
    Медиа — это профессия будущего. Управляйте вниманием, формируйте смыслы, влияйте на мир.
    Как поступить? Приёмная комиссия поможет вам определиться с направлением, собрать документы и пройти весь процесс поступления.
  `,
};
